<template>
  <v-layout row class="offset-2">
    <dialog-message
      v-if="error == 1"
      :error="error"
      :errorMessage="errorMsg"
      :messageType="messageType"
    ></dialog-message>
    <div>
      <v-snackbar
        v-model="snackbar"
        :right="x === 'right'"
        :timeout="timeout"
        :color="color"
        :top="y === 'top'"
      >
        {{ msg }}
        <v-btn color="white" flat @click="snackbar = false">Close</v-btn>
      </v-snackbar>
    </div>
    <v-layout xs12 class="offset-2">
      <v-container grid-list-md>
        <v-flex xs12 class="ml-2">
          <v-card-title class="white darken-1 text-xs-center">
            <span class="headline mx-auto black--text"
              >Delete User Request</span
            >
          </v-card-title>
          <v-card-text>
            <v-form ref="form" v-model="valid" lazy-validation>
              <!-- <v-layout wrap> -->

              <v-layout row>
                <v-flex xs12 class="mr-2">
                  <v-text-field
                    v-model="phone"
                    :rules="[(v) => !!v || 'Phone is required']"
                    label="Phone*"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row v-if="otp_sent">
                <v-flex xs12 class="mr-2">
                  <v-text-field
                    v-model="otp"
                    :rules="[(v) => !!v || 'OTP is required']"
                    label="OTP*"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row v-if="otp_sent">
                <v-flex xs12 class="ml-2">
                  <v-textarea
                    v-model="reason"
                    :rules="[(v) => !!v || 'Reason is required']"
                    label="Reason*"
                    required
                  ></v-textarea>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs12 class="ml-2">
                  <input type="file" @change="handleFileUpload" accept=".csv" />
                </v-flex>
              </v-layout>
              <!-- </v-layout> -->
              <!-- </v-container> -->
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              v-if="otp == '' && phone != ''"
              color="red darken-1"
              class="btn-large white--text"
              @click="sendOtp"
              >Request OTP</v-btn
            >
            <v-btn
              v-if="otp"
              color="red darken-1"
              class="btn-large white--text"
              @click="storeOrUpdate"
              >Request Delete</v-btn
            >
          </v-card-actions>
        </v-flex>
      </v-container>
    </v-layout>
  </v-layout>
</template>

<script>
import api from "../../api/datadash";
import { mapState } from "vuex";
import Papa from "papaparse";
import DialogMessage from "../../components/DialogMessage";

export default {
  components: {
    DialogMessage,
  },
  data: () => ({
    error: 0,
    errorMsg: "",
    valid: true,
    snackbar: false,
    msg: "Submitted successfully",
    y: "top",
    x: "right",
    timeout: 3000,
    dialog: false,
    otp_sent: false,
    phone: "",
    otp: "",
    reason: "",
  }),

  computed: {
    ...mapState(["auth"]),
  },
  async mounted() {
    // await this.getDivDistUpz();
  },

  created() {
    // this.initialize();
  },

  methods: {
    async storeOrUpdate() {
      this.loading = true;
      try {
        const { data } = await api.storeData(
          this.auth.token,
          "dasher-delete-request",
          {
            phone: this.phone,
            otp: this.otp,
            reason: this.reason,
          }
        );

        if (data.error) {
          this.color = "error";
          this.msg = data.errorMsg;
        } else {
          this.color = "success";
          this.msg = "User Delete request submitted successfully";
          this.$refs.form.reset();
        }

        this.snackbar = true;
        this.loading = false;
        this.close();
      } catch (e) {
        // console.log(e);
      }
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (file) {
        // You can now work with the selected CSV file
        // console.log("Selected file:", file);
        const columnData = [
          "question",
          "question_bangla",
          "question_variable",
          "required_optional",
          "multiple_answer",
          "ui_category_id",
        ];
        // Optionally, you can read the file's contents using FileReader
        const reader = new FileReader();
        reader.onload = () => {
          const fileContent = reader.result;
          Papa.parse(fileContent, {
            header: true, // If the first row contains headers
            complete: (result) => {
              const data = result.data; // Parsed data
              // console.log("Parsed data:", data);
              // console.log("Parsed data:", typeof(data[0]));
              const areAllElementsInArray2 = columnData.every((element) =>
                Object.keys(data[0]).includes(element)
              );
              if (!areAllElementsInArray2) {
                // console.log("columnData not match");
              }
              // Process the parsed data as needed
            },
          });
        };
        reader.readAsText(file);
      }
    },
    async sendOtp() {
      this.loading = true;

      this.errorMsg = "error message from otp";
      this.error = 1;
      this.messageType = "success";
      // try {
      //   const { data } = await api.storeData(this.auth.token, "send_otp", {
      //     phone: this.phone,
      //   });

      //   if (data.error) {
      //     this.color = "error";
      //     this.msg = data.errorMsg;
      //   } else {
      //     this.otp_sent = true;
      //     this.color = "success";
      //     this.msg = "OTP Send";
      //     // this.$refs.form.reset();
      //   }

      //   this.snackbar = true;
      //   this.loading = false;
      //   this.close();
      // } catch (e) {
      //   // console.log(e);
      // }
    },

    close() {
      this.dialog = false;
      setTimeout(() => {}, 300);
    },
  },
};
</script>
